module.exports = __webpack_public_path__ + "static/img/OOSH_078.a063e4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_078.jpg
// module id = y3LH
// module chunks = 170